import { css } from "styled-components";

const LinkStyle = css`
  color: ${({ theme }) => theme.colors.green600};
  text-decoration: none;
  font-weight: 500;
  margin-left: 0.5rem;
  &:hover {
    color: ${({ theme }) => theme.colors.green700};
  }
  &:active {
    color: ${({ theme }) => theme.colors.green800};
  }
`;

export default LinkStyle;
